import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { HomePage } from './pages/HomePage';
import { WorkPage } from './pages/WorkPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { DepartmentsPage } from './pages/DepartmentsPage';
import { EmployeesPage } from './pages/EmployeesPage';
import { JobsPage } from './pages/JobsPage';
import { InitiatoryInstructionItemsPage } from './pages/InitiatoryInstructionItemsPage';
import { FirePreventionInstructionItemsPage } from './pages/FirePreventionInstructionItemsPage';
import { LaborSafetyInstructionItemsPage } from './pages/LaborSafetyInstructionItemsPage';
import { ProbationInstructionItemsPage } from './pages/ProbationInstructionItemsPage';
import { EmployeeDocumentsPage } from './pages/EmployeeDocumentsPage';

const LayoutRoute: React.FC = () => (
  <CompanyProvider>
    <Layout>
      <Outlet />
    </Layout>
  </CompanyProvider>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route element={<RequireAuth />}>
            <Route element={<LayoutRoute />}>
              <Route path="/work" element={<WorkPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/departments" element={<DepartmentsPage />} />
              <Route path="/employees" element={<EmployeesPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/instructions" element={<InitiatoryInstructionItemsPage />} />
              <Route path="/fire-instructions" element={<FirePreventionInstructionItemsPage />} />
              <Route path="/labor-safety-instructions" element={<LaborSafetyInstructionItemsPage />} />
              <Route path="/probation-instructions" element={<ProbationInstructionItemsPage />} />
              <Route path="/employees/:employeeId/documents" element={<EmployeeDocumentsPage />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
